import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Typography,
  Avatar,
  TextField,
  CircularProgress,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../pages/app/Nurture/components/Nurture.module.css";
import highFlagIcon from "../FlagAssign/assets/High.svg";
import urgentFlagIcon from "../FlagAssign/assets/Urgent.svg";
import normalFlagIcon from "../FlagAssign/assets/Normal.svg";
import lowFlagIcon from "../FlagAssign/assets/Low.svg";
import defaultFlag from "../FlagAssign/assets/flag-default.svg";
import { GetLeadById } from "../../pages/app/Nurture/service/nurture.request";

const PillDropdown = ({
  value,
  options,
  backgroundColor,
  color,
  hoverBackgroundColor,
  isEmployee = false,
  isPriority = false,
  handleSelect,
  leadId,
  disabled,
  onCustomAdd,
  customAddLoading = false,
}: any) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isAddingTag, setIsAddingTag] = useState(false);
  const [newTagName, setNewTagName] = useState("");

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option?: any) => {
    if (option?.isCustom) {
      setIsAddingTag(true);
      return;
    }
    handleSelect(leadId, option);
    if (option) {
      GetLeadById(leadId)
        .then((res: any) => {
          localStorage.setItem("draggedInfo", JSON.stringify(res?.data?.data));
        })
        .catch(() => { });
    }
    setAnchorEl(null);
    setIsAddingTag(false);
    setNewTagName("");
  };

  const handleAddConfirm = () => {
    if (newTagName.trim() && onCustomAdd) {
      onCustomAdd(newTagName.trim());
      setIsAddingTag(false);
      setNewTagName("");
      setAnchorEl(null);
    }
  };

  const handleAddCancel = () => {
    setIsAddingTag(false);
    setNewTagName("");
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        sx={{
          backgroundColor: backgroundColor,
          color: color,
          textTransform: "capitalize",
          borderRadius: "999px",
          fontWeight: 600,
          px: 5,
          py: 0.5,
          fontSize: "12px",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: hoverBackgroundColor,
          },
        }}
        disabled={disabled}
      >
        {isEmployee && (
          <div
            className={styles.agentCardImg}
            style={{ marginRight: "5px" }}
          >
            <Avatar
              alt="avatar"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                fontSize: "17px",
                background: "#F5F5F7",
                border: "1px solid #EEEEF4",
                color: "#667085",
              }}
            >
              {value?.charAt(0)?.toUpperCase()}
            </Avatar>
          </div>
        )}
        {isPriority && (
          <div>
            <img
              src={
                value === "urgent"
                  ? urgentFlagIcon
                  : value === "high"
                    ? highFlagIcon
                    : value === "normal"
                      ? normalFlagIcon
                      : value === "low"
                        ? lowFlagIcon
                        : defaultFlag
              }
              alt=""
              style={{ marginRight: "5px", marginTop: "6px" }}
            />
          </div>
        )}
        {value}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        PaperProps={{
          sx: {
            borderRadius: 2,
            mt: 1,
            boxShadow: 2,
            px: 1,
          },
        }}
      >
        {isAddingTag ? (
          <Box sx={{ px: 1, py: 0.5, display: "flex", alignItems: "center", gap: "6px", minWidth: "200px" }}>
            <TextField
              value={newTagName}
              onChange={(e) => setNewTagName(e.target.value)}
              size="small"
              autoFocus
              placeholder="Enter tag name"
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") handleAddConfirm();
                if (e.key === "Escape") handleAddCancel();
              }}
              inputProps={{
                style: { padding: "6px 8px", fontSize: "12px" },
              }}
              sx={{ flex: 1 }}
            />
            {customAddLoading ? (
              <CircularProgress size={18} sx={{ color: "#11C89B" }} />
            ) : (
              <CheckIcon
                onClick={handleAddConfirm}
                sx={{
                  fontSize: 18,
                  color: newTagName.trim() ? "#11C89B" : "#ccc",
                  cursor: newTagName.trim() ? "pointer" : "default",
                }}
              />
            )}
            <CloseIcon
              onClick={handleAddCancel}
              sx={{ fontSize: 18, color: "#667085", cursor: "pointer" }}
            />
          </Box>
        ) : (
          options?.map((option: any) => (
            <MenuItem
              key={option?.value}
              onClick={() => handleClose(option)}
              sx={{
                fontSize: "12px",
                fontWeight: 400,
                color: "#6c757d",
                borderRadius: 1,
                "&:hover": { backgroundColor: "#f1f1f1" },
                textTransform: "capitalize",
              }}
            >
              {option?.icon && option.icon}
              <span style={option?.isCustom ? { color: "#11C89B" } : undefined}>
                {option?.label}
              </span>
            </MenuItem>
          ))
        )}
      </Menu>
    </Box>
  );
};

export default PillDropdown;
